// PrivateRoute.jsx
import React, { useEffect } from "react";
import { APP_PATHS } from '../utils/appPaths.js';
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../_helper/Auth/AuthProvider";
import { normalizeUserRole } from "../Layout/Sidebar/Menu";
import Error403 from "../Components/Pages/ErrorPages/ErrorPage403";
import Loader from "../Layout/Loader";

const PrivateRoute = ({ roles }) => {
  const { authenticated, userData, loading } = useAuth();
  const location = useLocation();
  useEffect(() => {
    localStorage.setItem("authenticated", JSON.stringify(authenticated));
  }, [authenticated]);

  if (loading) {
    return <Loader />;
  }

  if (!authenticated) {
    return <Navigate to={APP_PATHS.login} replace state={{ from: location }} />;
  }

  if (roles && roles.length > 0) {
    const roleDbStr = JSON.stringify(normalizeUserRole(userData?.role)).toLowerCase();
    const hasMatch = roles.some(reqRole => roleDbStr.includes(String(reqRole).toLowerCase()));
    if (!hasMatch) {
       localStorage.setItem("userDataRole", JSON.stringify(userData?.role));
       return <Error403 />;
    }
  }

  return <Outlet />;
};

export default PrivateRoute;